import { useQuery } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';

/**
 * Returns the currency symbol for a food point based on its asset.
 * Falls back to '₽' if the food point is not found or has no currency set.
 */
export function useFoodCurrency(foodID: string | number | undefined): string {
  const { data } = useQuery({
    queryFn: async () => {
      const response = await instance.get(`food-admin/${foodID}`);
      return response.data;
    },
    queryKey: ['food-item', foodID],
    enabled: !!foodID,
    staleTime: 5 * 60 * 1000,
  });

  return data?.assets?.currency ?? '$';
}
